export default "__VITE_ASSET__c12260f0__"